<app-admin-shell>
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Merchants</h1>
      <p class="page-header-subtitle">
        Businesses using Paierly and the public URL where their customers pay.
      </p>
    </div>
    <button type="button" class="btn btn-primary" (click)="addMerchant()">
      <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Add merchant
    </button>
  </div>

  <div *ngIf="isLoading" class="merchant-table-skeleton" aria-hidden="true">
    <div class="skeleton merchant-row-skeleton" *ngFor="let _ of [1, 2, 3]"></div>
  </div>

  <div *ngIf="!isLoading && hasError" class="state-panel card" role="alert" aria-live="polite">
    <span class="state-panel-icon">
      <svg class="icon icon-lg" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12" y2="13" />
        <line x1="12" y1="16" x2="12" y2="16.01" />
      </svg>
    </span>
    <h3 class="state-panel-title">We couldn't load merchants</h3>
    <p class="state-panel-body">The service didn't respond. Nothing was changed.</p>
    <button type="button" class="btn btn-primary" (click)="getMerchants()">
      Retry
    </button>
  </div>

  <ng-container *ngIf="!isLoading && !hasError">
    <div *ngIf="merchants.length === 0" class="state-panel card">
      <span class="state-panel-icon">
        <svg class="icon icon-lg" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M3 7l3-4h12l3 4" />
        </svg>
      </span>
      <h3 class="state-panel-title">No merchants yet</h3>
      <p class="state-panel-body">
        Add a business to generate its public payment URL and connect
        QuickBooks.
      </p>
      <button type="button" class="btn btn-primary" (click)="addMerchant()">
        Add merchant
      </button>
    </div>

    <table class="table table-responsive-cards" *ngIf="merchants.length > 0">
      <thead>
        <tr>
          <th scope="col">Merchant</th>
          <th scope="col">Public payment URL</th>
          <th scope="col">QuickBooks</th>
          <th scope="col" class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let merchant of merchants">
          <td data-label="Merchant">
            <div class="merchant-name-cell">
              <span class="merchant-initials" aria-hidden="true">{{
                merchant.name ? merchant.name.charAt(0).toUpperCase() : '?'
              }}</span>
              <span>{{ merchant.name }}</span>
            </div>
          </td>
          <td data-label="Public payment URL">
            <span class="company-id-code">{{ merchantUrlHost }}/merchant/{{ merchant.paymentLink }}</span>
          </td>
          <td data-label="QuickBooks">
            <span *ngIf="merchant.intuit?.companyId" class="badge badge-success">
              <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              Connected
            </span>
            <span *ngIf="!merchant.intuit?.companyId" class="badge badge-neutral">
              <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="9" y1="12" x2="15" y2="12" />
              </svg>
              Not connected
            </span>
          </td>
          <td data-label="Actions" class="table-cell-actions">
            <button
              type="button"
              class="btn-icon"
              [attr.aria-label]="'Edit ' + merchant.name"
              (click)="editMerchant(merchant.id)"
            >
              <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
              </svg>
            </button>
            <button
              type="button"
              class="btn-icon"
              [attr.aria-label]="'Delete ' + merchant.name"
              (click)="requestDelete(merchant)"
            >
              <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 6h18" />
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-caption merchant-count" *ngIf="merchants.length > 0">
      {{ merchants.length }} merchant{{ merchants.length === 1 ? '' : 's' }}
    </p>
  </ng-container>

  <app-confirm-dialog
    [open]="!!merchantPendingDelete"
    [title]="'Delete ' + (merchantPendingDelete?.name || 'this merchant') + '?'"
    message="Their public payment page will stop working immediately. Invoices already paid stay in QuickBooks."
    confirmLabel="Delete merchant"
    cancelLabel="Cancel"
    tone="danger"
    (confirmed)="confirmDelete()"
    (cancelled)="cancelDelete()"
  ></app-confirm-dialog>
</app-admin-shell>
